/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateCommunicationAppArea = /* GraphQL */ `
  subscription OnCreateCommunicationAppArea($appArea: String) {
    onCreateCommunicationAppArea(appArea: $appArea) {
      id
      subject
      body
      images
      video
      sendTo
      show
      publishDate
      topics
      listItems
      appArea
      countDownTo
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateCommunicationAppArea = /* GraphQL */ `
  subscription OnUpdateCommunicationAppArea($appArea: String) {
    onUpdateCommunicationAppArea(appArea: $appArea) {
      id
      subject
      body
      images
      video
      sendTo
      show
      publishDate
      topics
      listItems
      appArea
      countDownTo
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteCommunicationAppArea = /* GraphQL */ `
  subscription OnDeleteCommunicationAppArea($appArea: String) {
    onDeleteCommunicationAppArea(appArea: $appArea) {
      id
      subject
      body
      images
      video
      sendTo
      show
      publishDate
      topics
      listItems
      appArea
      countDownTo
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateEcwidCustomer = /* GraphQL */ `
  subscription OnCreateEcwidCustomer(
    $filter: ModelSubscriptionEcwidCustomerFilterInput
  ) {
    onCreateEcwidCustomer(filter: $filter) {
      customerId
      email
      acceptMarketing
      b2b_b2c
      billingPerson
      contacts
      customerGroupId
      customerGroupName
      electronicInvoicePecEmail
      electronicInvoiceSdiCode
      favorites
      fiscalCode
      lang
      name
      privateAdminNotes
      registered
      shippingAddresses
      stats
      taxExempt
      taxId
      taxIdValid
      totalOrderCount
      updated
      id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateEcwidCustomer = /* GraphQL */ `
  subscription OnUpdateEcwidCustomer(
    $filter: ModelSubscriptionEcwidCustomerFilterInput
  ) {
    onUpdateEcwidCustomer(filter: $filter) {
      customerId
      email
      acceptMarketing
      b2b_b2c
      billingPerson
      contacts
      customerGroupId
      customerGroupName
      electronicInvoicePecEmail
      electronicInvoiceSdiCode
      favorites
      fiscalCode
      lang
      name
      privateAdminNotes
      registered
      shippingAddresses
      stats
      taxExempt
      taxId
      taxIdValid
      totalOrderCount
      updated
      id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteEcwidCustomer = /* GraphQL */ `
  subscription OnDeleteEcwidCustomer(
    $filter: ModelSubscriptionEcwidCustomerFilterInput
  ) {
    onDeleteEcwidCustomer(filter: $filter) {
      customerId
      email
      acceptMarketing
      b2b_b2c
      billingPerson
      contacts
      customerGroupId
      customerGroupName
      electronicInvoicePecEmail
      electronicInvoiceSdiCode
      favorites
      fiscalCode
      lang
      name
      privateAdminNotes
      registered
      shippingAddresses
      stats
      taxExempt
      taxId
      taxIdValid
      totalOrderCount
      updated
      id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateEcwidProduct = /* GraphQL */ `
  subscription OnCreateEcwidProduct(
    $filter: ModelSubscriptionEcwidProductFilterInput
  ) {
    onCreateEcwidProduct(filter: $filter) {
      productId
      name
      sku
      thumbnailUrl
      unlimited
      inStock
      price
      priceInProductList
      defaultDisplayedPrice
      defaultDisplayedPriceFormatted
      tax
      lowestPrice
      defaultDisplayedLowestPrice
      defaultDisplayedLowestPriceFormatted
      lowestPriceSettings
      isShippingRequired
      hasFreeShipping
      url
      autogeneratedSlug
      customSlug
      created
      updated
      createTimestamp
      updateTimestamp
      productClassId
      enabled
      options
      warningLimit
      fixedShippingRateOnly
      fixedShippingRate
      shipping
      defaultCombinationId
      imageUrl
      smallThumbnailUrl
      hdThumbnailUrl
      originalImageUrl
      originalImage
      borderInfo
      description
      descriptionTranslated
      galleryImages
      media
      categoryIds
      categories
      defaultCategoryId
      seoTitle
      seoTitleTranslated
      seoDescription
      seoDescriptionTranslated
      favorites
      attributes
      files
      relatedProducts
      combinations
      dimensions
      shippingPreparationTime
      showDeliveryTimeInStorefront
      volume
      showOnFrontpage
      isSampleProduct
      googleItemCondition
      isGiftCard
      discountsAllowed
      nameYourPriceEnabled
      subscriptionSettings
      googleProductCategory
      googleProductCategoryName
      productCondition
      outOfStockVisibilityBehaviour
      nameTranslated
      id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateEcwidProduct = /* GraphQL */ `
  subscription OnUpdateEcwidProduct(
    $filter: ModelSubscriptionEcwidProductFilterInput
  ) {
    onUpdateEcwidProduct(filter: $filter) {
      productId
      name
      sku
      thumbnailUrl
      unlimited
      inStock
      price
      priceInProductList
      defaultDisplayedPrice
      defaultDisplayedPriceFormatted
      tax
      lowestPrice
      defaultDisplayedLowestPrice
      defaultDisplayedLowestPriceFormatted
      lowestPriceSettings
      isShippingRequired
      hasFreeShipping
      url
      autogeneratedSlug
      customSlug
      created
      updated
      createTimestamp
      updateTimestamp
      productClassId
      enabled
      options
      warningLimit
      fixedShippingRateOnly
      fixedShippingRate
      shipping
      defaultCombinationId
      imageUrl
      smallThumbnailUrl
      hdThumbnailUrl
      originalImageUrl
      originalImage
      borderInfo
      description
      descriptionTranslated
      galleryImages
      media
      categoryIds
      categories
      defaultCategoryId
      seoTitle
      seoTitleTranslated
      seoDescription
      seoDescriptionTranslated
      favorites
      attributes
      files
      relatedProducts
      combinations
      dimensions
      shippingPreparationTime
      showDeliveryTimeInStorefront
      volume
      showOnFrontpage
      isSampleProduct
      googleItemCondition
      isGiftCard
      discountsAllowed
      nameYourPriceEnabled
      subscriptionSettings
      googleProductCategory
      googleProductCategoryName
      productCondition
      outOfStockVisibilityBehaviour
      nameTranslated
      id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteEcwidProduct = /* GraphQL */ `
  subscription OnDeleteEcwidProduct(
    $filter: ModelSubscriptionEcwidProductFilterInput
  ) {
    onDeleteEcwidProduct(filter: $filter) {
      productId
      name
      sku
      thumbnailUrl
      unlimited
      inStock
      price
      priceInProductList
      defaultDisplayedPrice
      defaultDisplayedPriceFormatted
      tax
      lowestPrice
      defaultDisplayedLowestPrice
      defaultDisplayedLowestPriceFormatted
      lowestPriceSettings
      isShippingRequired
      hasFreeShipping
      url
      autogeneratedSlug
      customSlug
      created
      updated
      createTimestamp
      updateTimestamp
      productClassId
      enabled
      options
      warningLimit
      fixedShippingRateOnly
      fixedShippingRate
      shipping
      defaultCombinationId
      imageUrl
      smallThumbnailUrl
      hdThumbnailUrl
      originalImageUrl
      originalImage
      borderInfo
      description
      descriptionTranslated
      galleryImages
      media
      categoryIds
      categories
      defaultCategoryId
      seoTitle
      seoTitleTranslated
      seoDescription
      seoDescriptionTranslated
      favorites
      attributes
      files
      relatedProducts
      combinations
      dimensions
      shippingPreparationTime
      showDeliveryTimeInStorefront
      volume
      showOnFrontpage
      isSampleProduct
      googleItemCondition
      isGiftCard
      discountsAllowed
      nameYourPriceEnabled
      subscriptionSettings
      googleProductCategory
      googleProductCategoryName
      productCondition
      outOfStockVisibilityBehaviour
      nameTranslated
      id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateEcwidOrder = /* GraphQL */ `
  subscription OnCreateEcwidOrder(
    $filter: ModelSubscriptionEcwidOrderFilterInput
  ) {
    onCreateEcwidOrder(filter: $filter) {
      orderId
      internalId
      refundedAmount
      subtotal
      subtotalWithoutTax
      total
      totalWithoutTax
      giftCardRedemption
      totalBeforeGiftCardRedemption
      giftCardDoubleSpending
      email
      paymentMethod
      tax
      customerTaxExempt
      customerTaxId
      customerTaxIdValid
      b2b_b2c
      reversedTaxApplied
      customerRequestedInvoice
      customerFiscalCode
      electronicInvoicePecEmail
      electronicInvoiceSdiCode
      ipAddress
      couponDiscount
      paymentStatus
      fulfillmentStatus
      orderNumber
      vendorOrderNumber
      publicUid
      refererUrl
      orderComments
      volumeDiscount
      customerId
      membershipBasedDiscount
      totalAndMembershipBasedDiscount
      customDiscount
      customSurcharges
      discount
      usdTotal
      globalReferer
      createDate
      updateDate
      createTimestamp
      updateTimestamp
      items
      refunds
      billingPerson
      predictedPackage
      shippingLabelAvailableForShipment
      shipments
      additionalInfo
      paymentParams
      extraFields
      ticket
      hidden
      taxesOnShipping
      disableAllCustomerNotifications
      externalFulfillment
      utmDataSets
      invoices
      pricesIncludeTax
      loyalty
      customerUserAgent
      id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateEcwidOrder = /* GraphQL */ `
  subscription OnUpdateEcwidOrder(
    $filter: ModelSubscriptionEcwidOrderFilterInput
  ) {
    onUpdateEcwidOrder(filter: $filter) {
      orderId
      internalId
      refundedAmount
      subtotal
      subtotalWithoutTax
      total
      totalWithoutTax
      giftCardRedemption
      totalBeforeGiftCardRedemption
      giftCardDoubleSpending
      email
      paymentMethod
      tax
      customerTaxExempt
      customerTaxId
      customerTaxIdValid
      b2b_b2c
      reversedTaxApplied
      customerRequestedInvoice
      customerFiscalCode
      electronicInvoicePecEmail
      electronicInvoiceSdiCode
      ipAddress
      couponDiscount
      paymentStatus
      fulfillmentStatus
      orderNumber
      vendorOrderNumber
      publicUid
      refererUrl
      orderComments
      volumeDiscount
      customerId
      membershipBasedDiscount
      totalAndMembershipBasedDiscount
      customDiscount
      customSurcharges
      discount
      usdTotal
      globalReferer
      createDate
      updateDate
      createTimestamp
      updateTimestamp
      items
      refunds
      billingPerson
      predictedPackage
      shippingLabelAvailableForShipment
      shipments
      additionalInfo
      paymentParams
      extraFields
      ticket
      hidden
      taxesOnShipping
      disableAllCustomerNotifications
      externalFulfillment
      utmDataSets
      invoices
      pricesIncludeTax
      loyalty
      customerUserAgent
      id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteEcwidOrder = /* GraphQL */ `
  subscription OnDeleteEcwidOrder(
    $filter: ModelSubscriptionEcwidOrderFilterInput
  ) {
    onDeleteEcwidOrder(filter: $filter) {
      orderId
      internalId
      refundedAmount
      subtotal
      subtotalWithoutTax
      total
      totalWithoutTax
      giftCardRedemption
      totalBeforeGiftCardRedemption
      giftCardDoubleSpending
      email
      paymentMethod
      tax
      customerTaxExempt
      customerTaxId
      customerTaxIdValid
      b2b_b2c
      reversedTaxApplied
      customerRequestedInvoice
      customerFiscalCode
      electronicInvoicePecEmail
      electronicInvoiceSdiCode
      ipAddress
      couponDiscount
      paymentStatus
      fulfillmentStatus
      orderNumber
      vendorOrderNumber
      publicUid
      refererUrl
      orderComments
      volumeDiscount
      customerId
      membershipBasedDiscount
      totalAndMembershipBasedDiscount
      customDiscount
      customSurcharges
      discount
      usdTotal
      globalReferer
      createDate
      updateDate
      createTimestamp
      updateTimestamp
      items
      refunds
      billingPerson
      predictedPackage
      shippingLabelAvailableForShipment
      shipments
      additionalInfo
      paymentParams
      extraFields
      ticket
      hidden
      taxesOnShipping
      disableAllCustomerNotifications
      externalFulfillment
      utmDataSets
      invoices
      pricesIncludeTax
      loyalty
      customerUserAgent
      id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateEcwidCategory = /* GraphQL */ `
  subscription OnCreateEcwidCategory(
    $filter: ModelSubscriptionEcwidCategoryFilterInput
  ) {
    onCreateEcwidCategory(filter: $filter) {
      categoryId
      parentId
      orderBy
      hdThumbnailUrl
      thumbnailUrl
      imageUrl
      originalImageUrl
      originalImage
      thumbnail
      borderInfo
      name
      nameTranslated
      url
      autogeneratedSlug
      customSlug
      productCount
      enabledProductCount
      description
      descriptionTranslated
      enabled
      isSampleCategory
      seoTitle
      seoTitleTranslated
      seoDescription
      seoDescriptionTranslated
      alt
      id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateEcwidCategory = /* GraphQL */ `
  subscription OnUpdateEcwidCategory(
    $filter: ModelSubscriptionEcwidCategoryFilterInput
  ) {
    onUpdateEcwidCategory(filter: $filter) {
      categoryId
      parentId
      orderBy
      hdThumbnailUrl
      thumbnailUrl
      imageUrl
      originalImageUrl
      originalImage
      thumbnail
      borderInfo
      name
      nameTranslated
      url
      autogeneratedSlug
      customSlug
      productCount
      enabledProductCount
      description
      descriptionTranslated
      enabled
      isSampleCategory
      seoTitle
      seoTitleTranslated
      seoDescription
      seoDescriptionTranslated
      alt
      id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteEcwidCategory = /* GraphQL */ `
  subscription OnDeleteEcwidCategory(
    $filter: ModelSubscriptionEcwidCategoryFilterInput
  ) {
    onDeleteEcwidCategory(filter: $filter) {
      categoryId
      parentId
      orderBy
      hdThumbnailUrl
      thumbnailUrl
      imageUrl
      originalImageUrl
      originalImage
      thumbnail
      borderInfo
      name
      nameTranslated
      url
      autogeneratedSlug
      customSlug
      productCount
      enabledProductCount
      description
      descriptionTranslated
      enabled
      isSampleCategory
      seoTitle
      seoTitleTranslated
      seoDescription
      seoDescriptionTranslated
      alt
      id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateAppConfig = /* GraphQL */ `
  subscription OnCreateAppConfig(
    $filter: ModelSubscriptionAppConfigFilterInput
  ) {
    onCreateAppConfig(filter: $filter) {
      key
      enabled
      message
      createdAt
      updatedAt
      id
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateAppConfig = /* GraphQL */ `
  subscription OnUpdateAppConfig(
    $filter: ModelSubscriptionAppConfigFilterInput
  ) {
    onUpdateAppConfig(filter: $filter) {
      key
      enabled
      message
      createdAt
      updatedAt
      id
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteAppConfig = /* GraphQL */ `
  subscription OnDeleteAppConfig(
    $filter: ModelSubscriptionAppConfigFilterInput
  ) {
    onDeleteAppConfig(filter: $filter) {
      key
      enabled
      message
      createdAt
      updatedAt
      id
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateRedirect = /* GraphQL */ `
  subscription OnCreateRedirect($filter: ModelSubscriptionRedirectFilterInput) {
    onCreateRedirect(filter: $filter) {
      id
      oldPath
      newPath
      code
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateRedirect = /* GraphQL */ `
  subscription OnUpdateRedirect($filter: ModelSubscriptionRedirectFilterInput) {
    onUpdateRedirect(filter: $filter) {
      id
      oldPath
      newPath
      code
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteRedirect = /* GraphQL */ `
  subscription OnDeleteRedirect($filter: ModelSubscriptionRedirectFilterInput) {
    onDeleteRedirect(filter: $filter) {
      id
      oldPath
      newPath
      code
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateCoupon = /* GraphQL */ `
  subscription OnCreateCoupon($filter: ModelSubscriptionCouponFilterInput) {
    onCreateCoupon(filter: $filter) {
      id
      restrictTo
      startDate
      endDate
      discount
      enabled
      couponCode
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateCoupon = /* GraphQL */ `
  subscription OnUpdateCoupon($filter: ModelSubscriptionCouponFilterInput) {
    onUpdateCoupon(filter: $filter) {
      id
      restrictTo
      startDate
      endDate
      discount
      enabled
      couponCode
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteCoupon = /* GraphQL */ `
  subscription OnDeleteCoupon($filter: ModelSubscriptionCouponFilterInput) {
    onDeleteCoupon(filter: $filter) {
      id
      restrictTo
      startDate
      endDate
      discount
      enabled
      couponCode
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateSecret = /* GraphQL */ `
  subscription OnCreateSecret($filter: ModelSubscriptionSecretFilterInput) {
    onCreateSecret(filter: $filter) {
      id
      type
      value
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateSecret = /* GraphQL */ `
  subscription OnUpdateSecret($filter: ModelSubscriptionSecretFilterInput) {
    onUpdateSecret(filter: $filter) {
      id
      type
      value
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteSecret = /* GraphQL */ `
  subscription OnDeleteSecret($filter: ModelSubscriptionSecretFilterInput) {
    onDeleteSecret(filter: $filter) {
      id
      type
      value
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateAnnouncement = /* GraphQL */ `
  subscription OnCreateAnnouncement(
    $filter: ModelSubscriptionAnnouncementFilterInput
  ) {
    onCreateAnnouncement(filter: $filter) {
      id
      title
      sendTo
      readBy
      message
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateAnnouncement = /* GraphQL */ `
  subscription OnUpdateAnnouncement(
    $filter: ModelSubscriptionAnnouncementFilterInput
  ) {
    onUpdateAnnouncement(filter: $filter) {
      id
      title
      sendTo
      readBy
      message
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteAnnouncement = /* GraphQL */ `
  subscription OnDeleteAnnouncement(
    $filter: ModelSubscriptionAnnouncementFilterInput
  ) {
    onDeleteAnnouncement(filter: $filter) {
      id
      title
      sendTo
      readBy
      message
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateCommunication = /* GraphQL */ `
  subscription OnCreateCommunication(
    $filter: ModelSubscriptionCommunicationFilterInput
  ) {
    onCreateCommunication(filter: $filter) {
      id
      subject
      body
      images
      video
      sendTo
      show
      publishDate
      topics
      listItems
      appArea
      countDownTo
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateCommunication = /* GraphQL */ `
  subscription OnUpdateCommunication(
    $filter: ModelSubscriptionCommunicationFilterInput
  ) {
    onUpdateCommunication(filter: $filter) {
      id
      subject
      body
      images
      video
      sendTo
      show
      publishDate
      topics
      listItems
      appArea
      countDownTo
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteCommunication = /* GraphQL */ `
  subscription OnDeleteCommunication(
    $filter: ModelSubscriptionCommunicationFilterInput
  ) {
    onDeleteCommunication(filter: $filter) {
      id
      subject
      body
      images
      video
      sendTo
      show
      publishDate
      topics
      listItems
      appArea
      countDownTo
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateCommunicationTopic = /* GraphQL */ `
  subscription OnCreateCommunicationTopic(
    $filter: ModelSubscriptionCommunicationTopicFilterInput
  ) {
    onCreateCommunicationTopic(filter: $filter) {
      id
      title
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateCommunicationTopic = /* GraphQL */ `
  subscription OnUpdateCommunicationTopic(
    $filter: ModelSubscriptionCommunicationTopicFilterInput
  ) {
    onUpdateCommunicationTopic(filter: $filter) {
      id
      title
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteCommunicationTopic = /* GraphQL */ `
  subscription OnDeleteCommunicationTopic(
    $filter: ModelSubscriptionCommunicationTopicFilterInput
  ) {
    onDeleteCommunicationTopic(filter: $filter) {
      id
      title
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateSubscriptionPackage = /* GraphQL */ `
  subscription OnCreateSubscriptionPackage(
    $filter: ModelSubscriptionSubscriptionPackageFilterInput
  ) {
    onCreateSubscriptionPackage(filter: $filter) {
      id
      name
      package
      schoolID
      subjectIDs
      active
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateSubscriptionPackage = /* GraphQL */ `
  subscription OnUpdateSubscriptionPackage(
    $filter: ModelSubscriptionSubscriptionPackageFilterInput
  ) {
    onUpdateSubscriptionPackage(filter: $filter) {
      id
      name
      package
      schoolID
      subjectIDs
      active
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteSubscriptionPackage = /* GraphQL */ `
  subscription OnDeleteSubscriptionPackage(
    $filter: ModelSubscriptionSubscriptionPackageFilterInput
  ) {
    onDeleteSubscriptionPackage(filter: $filter) {
      id
      name
      package
      schoolID
      subjectIDs
      active
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateSubscriptionAccess = /* GraphQL */ `
  subscription OnCreateSubscriptionAccess(
    $filter: ModelSubscriptionSubscriptionAccessFilterInput
    $email: String
  ) {
    onCreateSubscriptionAccess(filter: $filter, email: $email) {
      id
      email
      subscriptionPackageID
      subjectIDs
      active
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateSubscriptionAccess = /* GraphQL */ `
  subscription OnUpdateSubscriptionAccess(
    $filter: ModelSubscriptionSubscriptionAccessFilterInput
    $email: String
  ) {
    onUpdateSubscriptionAccess(filter: $filter, email: $email) {
      id
      email
      subscriptionPackageID
      subjectIDs
      active
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteSubscriptionAccess = /* GraphQL */ `
  subscription OnDeleteSubscriptionAccess(
    $filter: ModelSubscriptionSubscriptionAccessFilterInput
    $email: String
  ) {
    onDeleteSubscriptionAccess(filter: $filter, email: $email) {
      id
      email
      subscriptionPackageID
      subjectIDs
      active
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateTeacherProductsOrder = /* GraphQL */ `
  subscription OnCreateTeacherProductsOrder(
    $filter: ModelSubscriptionTeacherProductsOrderFilterInput
    $owner: String
  ) {
    onCreateTeacherProductsOrder(filter: $filter, owner: $owner) {
      id
      teacherprofileID
      orderShippingDetails
      orderDateTime
      orderStatus
      orderProducts
      orderTotal
      orderVAT
      orderID
      orderPayment
      orderPaymentMethod
      coupon
      notes
      meta
      thankyouTokenHash
      updatedAtMonth
      createdAtMonth
      createdAt
      updatedAt
      owner
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateTeacherProductsOrder = /* GraphQL */ `
  subscription OnUpdateTeacherProductsOrder(
    $filter: ModelSubscriptionTeacherProductsOrderFilterInput
    $owner: String
  ) {
    onUpdateTeacherProductsOrder(filter: $filter, owner: $owner) {
      id
      teacherprofileID
      orderShippingDetails
      orderDateTime
      orderStatus
      orderProducts
      orderTotal
      orderVAT
      orderID
      orderPayment
      orderPaymentMethod
      coupon
      notes
      meta
      thankyouTokenHash
      updatedAtMonth
      createdAtMonth
      createdAt
      updatedAt
      owner
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteTeacherProductsOrder = /* GraphQL */ `
  subscription OnDeleteTeacherProductsOrder(
    $filter: ModelSubscriptionTeacherProductsOrderFilterInput
    $owner: String
  ) {
    onDeleteTeacherProductsOrder(filter: $filter, owner: $owner) {
      id
      teacherprofileID
      orderShippingDetails
      orderDateTime
      orderStatus
      orderProducts
      orderTotal
      orderVAT
      orderID
      orderPayment
      orderPaymentMethod
      coupon
      notes
      meta
      thankyouTokenHash
      updatedAtMonth
      createdAtMonth
      createdAt
      updatedAt
      owner
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateReportingOrderProducts = /* GraphQL */ `
  subscription OnCreateReportingOrderProducts(
    $filter: ModelSubscriptionReportingOrderProductsFilterInput
  ) {
    onCreateReportingOrderProducts(filter: $filter) {
      id
      teacherprofileID
      isRecommended
      price
      teacherproductsorderID
      addOnType
      createdAt
      updatedAt
      productID
      productBundleID
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateReportingOrderProducts = /* GraphQL */ `
  subscription OnUpdateReportingOrderProducts(
    $filter: ModelSubscriptionReportingOrderProductsFilterInput
  ) {
    onUpdateReportingOrderProducts(filter: $filter) {
      id
      teacherprofileID
      isRecommended
      price
      teacherproductsorderID
      addOnType
      createdAt
      updatedAt
      productID
      productBundleID
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteReportingOrderProducts = /* GraphQL */ `
  subscription OnDeleteReportingOrderProducts(
    $filter: ModelSubscriptionReportingOrderProductsFilterInput
  ) {
    onDeleteReportingOrderProducts(filter: $filter) {
      id
      teacherprofileID
      isRecommended
      price
      teacherproductsorderID
      addOnType
      createdAt
      updatedAt
      productID
      productBundleID
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateArchivedTeacherProductsOrder = /* GraphQL */ `
  subscription OnCreateArchivedTeacherProductsOrder(
    $filter: ModelSubscriptionArchivedTeacherProductsOrderFilterInput
    $owner: String
  ) {
    onCreateArchivedTeacherProductsOrder(filter: $filter, owner: $owner) {
      id
      teacherprofileID
      orderShippingDetails
      orderDateTime
      orderStatus
      orderProducts
      orderTotal
      orderVAT
      orderID
      orderPayment
      orderPaymentMethod
      coupon
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateArchivedTeacherProductsOrder = /* GraphQL */ `
  subscription OnUpdateArchivedTeacherProductsOrder(
    $filter: ModelSubscriptionArchivedTeacherProductsOrderFilterInput
    $owner: String
  ) {
    onUpdateArchivedTeacherProductsOrder(filter: $filter, owner: $owner) {
      id
      teacherprofileID
      orderShippingDetails
      orderDateTime
      orderStatus
      orderProducts
      orderTotal
      orderVAT
      orderID
      orderPayment
      orderPaymentMethod
      coupon
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteArchivedTeacherProductsOrder = /* GraphQL */ `
  subscription OnDeleteArchivedTeacherProductsOrder(
    $filter: ModelSubscriptionArchivedTeacherProductsOrderFilterInput
    $owner: String
  ) {
    onDeleteArchivedTeacherProductsOrder(filter: $filter, owner: $owner) {
      id
      teacherprofileID
      orderShippingDetails
      orderDateTime
      orderStatus
      orderProducts
      orderTotal
      orderVAT
      orderID
      orderPayment
      orderPaymentMethod
      coupon
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateProductCategory = /* GraphQL */ `
  subscription OnCreateProductCategory(
    $filter: ModelSubscriptionProductCategoryFilterInput
  ) {
    onCreateProductCategory(filter: $filter) {
      id
      name
      slug
      parentId
      grade
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateProductCategory = /* GraphQL */ `
  subscription OnUpdateProductCategory(
    $filter: ModelSubscriptionProductCategoryFilterInput
  ) {
    onUpdateProductCategory(filter: $filter) {
      id
      name
      slug
      parentId
      grade
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteProductCategory = /* GraphQL */ `
  subscription OnDeleteProductCategory(
    $filter: ModelSubscriptionProductCategoryFilterInput
  ) {
    onDeleteProductCategory(filter: $filter) {
      id
      name
      slug
      parentId
      grade
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateProductTag = /* GraphQL */ `
  subscription OnCreateProductTag(
    $filter: ModelSubscriptionProductTagFilterInput
  ) {
    onCreateProductTag(filter: $filter) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateProductTag = /* GraphQL */ `
  subscription OnUpdateProductTag(
    $filter: ModelSubscriptionProductTagFilterInput
  ) {
    onUpdateProductTag(filter: $filter) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteProductTag = /* GraphQL */ `
  subscription OnDeleteProductTag(
    $filter: ModelSubscriptionProductTagFilterInput
  ) {
    onDeleteProductTag(filter: $filter) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateProductContent = /* GraphQL */ `
  subscription OnCreateProductContent(
    $filter: ModelSubscriptionProductContentFilterInput
  ) {
    onCreateProductContent(filter: $filter) {
      id
      productId
      fileKeys
      urls
      addons
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateProductContent = /* GraphQL */ `
  subscription OnUpdateProductContent(
    $filter: ModelSubscriptionProductContentFilterInput
  ) {
    onUpdateProductContent(filter: $filter) {
      id
      productId
      fileKeys
      urls
      addons
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteProductContent = /* GraphQL */ `
  subscription OnDeleteProductContent(
    $filter: ModelSubscriptionProductContentFilterInput
  ) {
    onDeleteProductContent(filter: $filter) {
      id
      productId
      fileKeys
      urls
      addons
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateJustBoughtProduct = /* GraphQL */ `
  subscription OnCreateJustBoughtProduct(
    $filter: ModelSubscriptionJustBoughtProductFilterInput
  ) {
    onCreateJustBoughtProduct(filter: $filter) {
      id
      productID
      productBundleID
      Product {
        id
        title
        description
        price
        discountPercentage
        eCommerceProduct
        subscriptionProduct
        thumbnails
        videoPreview
        tags
        publishDate
        featured
        physical
        searchField
        categoryId
        subjectID
        questions
        sku
        softDeleted
        addons
        recommendations
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ProductBundle {
        id
        title
        description
        price
        discountPercentage
        thumbnails
        videoPreview
        products
        tags
        publishDate
        featured
        searchField
        recommendations
        categoryId
        subjectID
        softDeleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      categoryId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateJustBoughtProduct = /* GraphQL */ `
  subscription OnUpdateJustBoughtProduct(
    $filter: ModelSubscriptionJustBoughtProductFilterInput
  ) {
    onUpdateJustBoughtProduct(filter: $filter) {
      id
      productID
      productBundleID
      Product {
        id
        title
        description
        price
        discountPercentage
        eCommerceProduct
        subscriptionProduct
        thumbnails
        videoPreview
        tags
        publishDate
        featured
        physical
        searchField
        categoryId
        subjectID
        questions
        sku
        softDeleted
        addons
        recommendations
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ProductBundle {
        id
        title
        description
        price
        discountPercentage
        thumbnails
        videoPreview
        products
        tags
        publishDate
        featured
        searchField
        recommendations
        categoryId
        subjectID
        softDeleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      categoryId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteJustBoughtProduct = /* GraphQL */ `
  subscription OnDeleteJustBoughtProduct(
    $filter: ModelSubscriptionJustBoughtProductFilterInput
  ) {
    onDeleteJustBoughtProduct(filter: $filter) {
      id
      productID
      productBundleID
      Product {
        id
        title
        description
        price
        discountPercentage
        eCommerceProduct
        subscriptionProduct
        thumbnails
        videoPreview
        tags
        publishDate
        featured
        physical
        searchField
        categoryId
        subjectID
        questions
        sku
        softDeleted
        addons
        recommendations
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ProductBundle {
        id
        title
        description
        price
        discountPercentage
        thumbnails
        videoPreview
        products
        tags
        publishDate
        featured
        searchField
        recommendations
        categoryId
        subjectID
        softDeleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      categoryId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateProductSEO = /* GraphQL */ `
  subscription OnCreateProductSEO(
    $filter: ModelSubscriptionProductSEOFilterInput
  ) {
    onCreateProductSEO(filter: $filter) {
      id
      seoId
      productID
      productBundleID
      Product {
        id
        title
        description
        price
        discountPercentage
        eCommerceProduct
        subscriptionProduct
        thumbnails
        videoPreview
        tags
        publishDate
        featured
        physical
        searchField
        categoryId
        subjectID
        questions
        sku
        softDeleted
        addons
        recommendations
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ProductBundle {
        id
        title
        description
        price
        discountPercentage
        thumbnails
        videoPreview
        products
        tags
        publishDate
        featured
        searchField
        recommendations
        categoryId
        subjectID
        softDeleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateProductSEO = /* GraphQL */ `
  subscription OnUpdateProductSEO(
    $filter: ModelSubscriptionProductSEOFilterInput
  ) {
    onUpdateProductSEO(filter: $filter) {
      id
      seoId
      productID
      productBundleID
      Product {
        id
        title
        description
        price
        discountPercentage
        eCommerceProduct
        subscriptionProduct
        thumbnails
        videoPreview
        tags
        publishDate
        featured
        physical
        searchField
        categoryId
        subjectID
        questions
        sku
        softDeleted
        addons
        recommendations
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ProductBundle {
        id
        title
        description
        price
        discountPercentage
        thumbnails
        videoPreview
        products
        tags
        publishDate
        featured
        searchField
        recommendations
        categoryId
        subjectID
        softDeleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteProductSEO = /* GraphQL */ `
  subscription OnDeleteProductSEO(
    $filter: ModelSubscriptionProductSEOFilterInput
  ) {
    onDeleteProductSEO(filter: $filter) {
      id
      seoId
      productID
      productBundleID
      Product {
        id
        title
        description
        price
        discountPercentage
        eCommerceProduct
        subscriptionProduct
        thumbnails
        videoPreview
        tags
        publishDate
        featured
        physical
        searchField
        categoryId
        subjectID
        questions
        sku
        softDeleted
        addons
        recommendations
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ProductBundle {
        id
        title
        description
        price
        discountPercentage
        thumbnails
        videoPreview
        products
        tags
        publishDate
        featured
        searchField
        recommendations
        categoryId
        subjectID
        softDeleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateProductBundle = /* GraphQL */ `
  subscription OnCreateProductBundle(
    $filter: ModelSubscriptionProductBundleFilterInput
  ) {
    onCreateProductBundle(filter: $filter) {
      id
      title
      description
      price
      discountPercentage
      thumbnails
      videoPreview
      products
      tags
      publishDate
      featured
      searchField
      recommendations
      categoryId
      subjectID
      softDeleted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateProductBundle = /* GraphQL */ `
  subscription OnUpdateProductBundle(
    $filter: ModelSubscriptionProductBundleFilterInput
  ) {
    onUpdateProductBundle(filter: $filter) {
      id
      title
      description
      price
      discountPercentage
      thumbnails
      videoPreview
      products
      tags
      publishDate
      featured
      searchField
      recommendations
      categoryId
      subjectID
      softDeleted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteProductBundle = /* GraphQL */ `
  subscription OnDeleteProductBundle(
    $filter: ModelSubscriptionProductBundleFilterInput
  ) {
    onDeleteProductBundle(filter: $filter) {
      id
      title
      description
      price
      discountPercentage
      thumbnails
      videoPreview
      products
      tags
      publishDate
      featured
      searchField
      recommendations
      categoryId
      subjectID
      softDeleted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateProduct = /* GraphQL */ `
  subscription OnCreateProduct($filter: ModelSubscriptionProductFilterInput) {
    onCreateProduct(filter: $filter) {
      id
      title
      description
      price
      discountPercentage
      eCommerceProduct
      subscriptionProduct
      thumbnails
      videoPreview
      tags
      publishDate
      featured
      physical
      searchField
      categoryId
      subjectID
      questions
      sku
      softDeleted
      addons
      recommendations
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateProduct = /* GraphQL */ `
  subscription OnUpdateProduct($filter: ModelSubscriptionProductFilterInput) {
    onUpdateProduct(filter: $filter) {
      id
      title
      description
      price
      discountPercentage
      eCommerceProduct
      subscriptionProduct
      thumbnails
      videoPreview
      tags
      publishDate
      featured
      physical
      searchField
      categoryId
      subjectID
      questions
      sku
      softDeleted
      addons
      recommendations
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteProduct = /* GraphQL */ `
  subscription OnDeleteProduct($filter: ModelSubscriptionProductFilterInput) {
    onDeleteProduct(filter: $filter) {
      id
      title
      description
      price
      discountPercentage
      eCommerceProduct
      subscriptionProduct
      thumbnails
      videoPreview
      tags
      publishDate
      featured
      physical
      searchField
      categoryId
      subjectID
      questions
      sku
      softDeleted
      addons
      recommendations
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateTaxonomy = /* GraphQL */ `
  subscription OnCreateTaxonomy($filter: ModelSubscriptionTaxonomyFilterInput) {
    onCreateTaxonomy(filter: $filter) {
      id
      name
      cognitiveLevels {
        label
        percentage
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateTaxonomy = /* GraphQL */ `
  subscription OnUpdateTaxonomy($filter: ModelSubscriptionTaxonomyFilterInput) {
    onUpdateTaxonomy(filter: $filter) {
      id
      name
      cognitiveLevels {
        label
        percentage
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteTaxonomy = /* GraphQL */ `
  subscription OnDeleteTaxonomy($filter: ModelSubscriptionTaxonomyFilterInput) {
    onDeleteTaxonomy(filter: $filter) {
      id
      name
      cognitiveLevels {
        label
        percentage
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateTeacherAssessmentTemplate = /* GraphQL */ `
  subscription OnCreateTeacherAssessmentTemplate(
    $filter: ModelSubscriptionTeacherAssessmentTemplateFilterInput
    $owner: String
  ) {
    onCreateTeacherAssessmentTemplate(filter: $filter, owner: $owner) {
      id
      title
      headings
      fontFamily
      complexity
      totalMarks
      totalMinutes
      questions
      TeacherActivities {
        nextToken
        startedAt
        __typename
      }
      instructions
      taxonomy
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const onUpdateTeacherAssessmentTemplate = /* GraphQL */ `
  subscription OnUpdateTeacherAssessmentTemplate(
    $filter: ModelSubscriptionTeacherAssessmentTemplateFilterInput
    $owner: String
  ) {
    onUpdateTeacherAssessmentTemplate(filter: $filter, owner: $owner) {
      id
      title
      headings
      fontFamily
      complexity
      totalMarks
      totalMinutes
      questions
      TeacherActivities {
        nextToken
        startedAt
        __typename
      }
      instructions
      taxonomy
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const onDeleteTeacherAssessmentTemplate = /* GraphQL */ `
  subscription OnDeleteTeacherAssessmentTemplate(
    $filter: ModelSubscriptionTeacherAssessmentTemplateFilterInput
    $owner: String
  ) {
    onDeleteTeacherAssessmentTemplate(filter: $filter, owner: $owner) {
      id
      title
      headings
      fontFamily
      complexity
      totalMarks
      totalMinutes
      questions
      TeacherActivities {
        nextToken
        startedAt
        __typename
      }
      instructions
      taxonomy
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const onCreateAssessmentTemplate = /* GraphQL */ `
  subscription OnCreateAssessmentTemplate(
    $filter: ModelSubscriptionAssessmentTemplateFilterInput
  ) {
    onCreateAssessmentTemplate(filter: $filter) {
      id
      title
      headings
      fontFamily
      complexity
      totalMarks
      totalMinutes
      questions
      instructions
      taxonomys
      schoolID
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateAssessmentTemplate = /* GraphQL */ `
  subscription OnUpdateAssessmentTemplate(
    $filter: ModelSubscriptionAssessmentTemplateFilterInput
  ) {
    onUpdateAssessmentTemplate(filter: $filter) {
      id
      title
      headings
      fontFamily
      complexity
      totalMarks
      totalMinutes
      questions
      instructions
      taxonomys
      schoolID
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteAssessmentTemplate = /* GraphQL */ `
  subscription OnDeleteAssessmentTemplate(
    $filter: ModelSubscriptionAssessmentTemplateFilterInput
  ) {
    onDeleteAssessmentTemplate(filter: $filter) {
      id
      title
      headings
      fontFamily
      complexity
      totalMarks
      totalMinutes
      questions
      instructions
      taxonomys
      schoolID
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateTeacherSubjectTemplate = /* GraphQL */ `
  subscription OnCreateTeacherSubjectTemplate(
    $filter: ModelSubscriptionTeacherSubjectTemplateFilterInput
    $owner: String
  ) {
    onCreateTeacherSubjectTemplate(filter: $filter, owner: $owner) {
      id
      name
      headings
      fontFamily
      complexity
      totalPoints
      minutes
      template
      TeacherActivities {
        nextToken
        startedAt
        __typename
      }
      schoolID
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const onUpdateTeacherSubjectTemplate = /* GraphQL */ `
  subscription OnUpdateTeacherSubjectTemplate(
    $filter: ModelSubscriptionTeacherSubjectTemplateFilterInput
    $owner: String
  ) {
    onUpdateTeacherSubjectTemplate(filter: $filter, owner: $owner) {
      id
      name
      headings
      fontFamily
      complexity
      totalPoints
      minutes
      template
      TeacherActivities {
        nextToken
        startedAt
        __typename
      }
      schoolID
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const onDeleteTeacherSubjectTemplate = /* GraphQL */ `
  subscription OnDeleteTeacherSubjectTemplate(
    $filter: ModelSubscriptionTeacherSubjectTemplateFilterInput
    $owner: String
  ) {
    onDeleteTeacherSubjectTemplate(filter: $filter, owner: $owner) {
      id
      name
      headings
      fontFamily
      complexity
      totalPoints
      minutes
      template
      TeacherActivities {
        nextToken
        startedAt
        __typename
      }
      schoolID
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const onCreateSubjectTemplate = /* GraphQL */ `
  subscription OnCreateSubjectTemplate(
    $filter: ModelSubscriptionSubjectTemplateFilterInput
  ) {
    onCreateSubjectTemplate(filter: $filter) {
      id
      name
      headings
      fontFamily
      complexity
      totalPoints
      minutes
      template
      subjectID
      schoolID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateSubjectTemplate = /* GraphQL */ `
  subscription OnUpdateSubjectTemplate(
    $filter: ModelSubscriptionSubjectTemplateFilterInput
  ) {
    onUpdateSubjectTemplate(filter: $filter) {
      id
      name
      headings
      fontFamily
      complexity
      totalPoints
      minutes
      template
      subjectID
      schoolID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteSubjectTemplate = /* GraphQL */ `
  subscription OnDeleteSubjectTemplate(
    $filter: ModelSubscriptionSubjectTemplateFilterInput
  ) {
    onDeleteSubjectTemplate(filter: $filter) {
      id
      name
      headings
      fontFamily
      complexity
      totalPoints
      minutes
      template
      subjectID
      schoolID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateSchool = /* GraphQL */ `
  subscription OnCreateSchool($filter: ModelSubscriptionSchoolFilterInput) {
    onCreateSchool(filter: $filter) {
      id
      name
      provinces
      isGeneric
      SubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      TeacherSubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      AssessmentTemplates {
        nextToken
        startedAt
        __typename
      }
      schoolImgKey
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateSchool = /* GraphQL */ `
  subscription OnUpdateSchool($filter: ModelSubscriptionSchoolFilterInput) {
    onUpdateSchool(filter: $filter) {
      id
      name
      provinces
      isGeneric
      SubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      TeacherSubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      AssessmentTemplates {
        nextToken
        startedAt
        __typename
      }
      schoolImgKey
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteSchool = /* GraphQL */ `
  subscription OnDeleteSchool($filter: ModelSubscriptionSchoolFilterInput) {
    onDeleteSchool(filter: $filter) {
      id
      name
      provinces
      isGeneric
      SubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      TeacherSubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      AssessmentTemplates {
        nextToken
        startedAt
        __typename
      }
      schoolImgKey
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateTeacherActivity = /* GraphQL */ `
  subscription OnCreateTeacherActivity(
    $filter: ModelSubscriptionTeacherActivityFilterInput
    $owner: String
  ) {
    onCreateTeacherActivity(filter: $filter, owner: $owner) {
      id
      label
      type
      endDateTime
      color
      teacherprofileID
      teachersubjecttemplateID
      teacherassessmenttemplateID
      startDateTime
      repeatID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const onUpdateTeacherActivity = /* GraphQL */ `
  subscription OnUpdateTeacherActivity(
    $filter: ModelSubscriptionTeacherActivityFilterInput
    $owner: String
  ) {
    onUpdateTeacherActivity(filter: $filter, owner: $owner) {
      id
      label
      type
      endDateTime
      color
      teacherprofileID
      teachersubjecttemplateID
      teacherassessmenttemplateID
      startDateTime
      repeatID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const onDeleteTeacherActivity = /* GraphQL */ `
  subscription OnDeleteTeacherActivity(
    $filter: ModelSubscriptionTeacherActivityFilterInput
    $owner: String
  ) {
    onDeleteTeacherActivity(filter: $filter, owner: $owner) {
      id
      label
      type
      endDateTime
      color
      teacherprofileID
      teachersubjecttemplateID
      teacherassessmenttemplateID
      startDateTime
      repeatID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const onCreateTerm = /* GraphQL */ `
  subscription OnCreateTerm($filter: ModelSubscriptionTermFilterInput) {
    onCreateTerm(filter: $filter) {
      id
      label
      start
      end
      biweeks {
        label
        start
        end
        color
        __typename
      }
      provinces
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateTerm = /* GraphQL */ `
  subscription OnUpdateTerm($filter: ModelSubscriptionTermFilterInput) {
    onUpdateTerm(filter: $filter) {
      id
      label
      start
      end
      biweeks {
        label
        start
        end
        color
        __typename
      }
      provinces
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteTerm = /* GraphQL */ `
  subscription OnDeleteTerm($filter: ModelSubscriptionTermFilterInput) {
    onDeleteTerm(filter: $filter) {
      id
      label
      start
      end
      biweeks {
        label
        start
        end
        color
        __typename
      }
      provinces
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateHoliday = /* GraphQL */ `
  subscription OnCreateHoliday($filter: ModelSubscriptionHolidayFilterInput) {
    onCreateHoliday(filter: $filter) {
      id
      label
      date
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateHoliday = /* GraphQL */ `
  subscription OnUpdateHoliday($filter: ModelSubscriptionHolidayFilterInput) {
    onUpdateHoliday(filter: $filter) {
      id
      label
      date
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteHoliday = /* GraphQL */ `
  subscription OnDeleteHoliday($filter: ModelSubscriptionHolidayFilterInput) {
    onDeleteHoliday(filter: $filter) {
      id
      label
      date
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateTeacherClassSubject = /* GraphQL */ `
  subscription OnCreateTeacherClassSubject(
    $filter: ModelSubscriptionTeacherClassSubjectFilterInput
    $owner: String
  ) {
    onCreateTeacherClassSubject(filter: $filter, owner: $owner) {
      id
      name
      teacherprofileID
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const onUpdateTeacherClassSubject = /* GraphQL */ `
  subscription OnUpdateTeacherClassSubject(
    $filter: ModelSubscriptionTeacherClassSubjectFilterInput
    $owner: String
  ) {
    onUpdateTeacherClassSubject(filter: $filter, owner: $owner) {
      id
      name
      teacherprofileID
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const onDeleteTeacherClassSubject = /* GraphQL */ `
  subscription OnDeleteTeacherClassSubject(
    $filter: ModelSubscriptionTeacherClassSubjectFilterInput
    $owner: String
  ) {
    onDeleteTeacherClassSubject(filter: $filter, owner: $owner) {
      id
      name
      teacherprofileID
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const onCreateSubject = /* GraphQL */ `
  subscription OnCreateSubject($filter: ModelSubscriptionSubjectFilterInput) {
    onCreateSubject(filter: $filter) {
      id
      grade
      subject
      TeacherClassSubjects {
        nextToken
        startedAt
        __typename
      }
      SubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      TeacherSubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      AssessmentTemplates {
        nextToken
        startedAt
        __typename
      }
      TeacherAssessmentTemplates {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateSubject = /* GraphQL */ `
  subscription OnUpdateSubject($filter: ModelSubscriptionSubjectFilterInput) {
    onUpdateSubject(filter: $filter) {
      id
      grade
      subject
      TeacherClassSubjects {
        nextToken
        startedAt
        __typename
      }
      SubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      TeacherSubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      AssessmentTemplates {
        nextToken
        startedAt
        __typename
      }
      TeacherAssessmentTemplates {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteSubject = /* GraphQL */ `
  subscription OnDeleteSubject($filter: ModelSubscriptionSubjectFilterInput) {
    onDeleteSubject(filter: $filter) {
      id
      grade
      subject
      TeacherClassSubjects {
        nextToken
        startedAt
        __typename
      }
      SubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      TeacherSubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      AssessmentTemplates {
        nextToken
        startedAt
        __typename
      }
      TeacherAssessmentTemplates {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateTeacherSchedule = /* GraphQL */ `
  subscription OnCreateTeacherSchedule(
    $filter: ModelSubscriptionTeacherScheduleFilterInput
    $owner: String
  ) {
    onCreateTeacherSchedule(filter: $filter, owner: $owner) {
      id
      day
      periods
      periodDuration
      breakDurations
      startTime
      endTime
      teacherprofileID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const onUpdateTeacherSchedule = /* GraphQL */ `
  subscription OnUpdateTeacherSchedule(
    $filter: ModelSubscriptionTeacherScheduleFilterInput
    $owner: String
  ) {
    onUpdateTeacherSchedule(filter: $filter, owner: $owner) {
      id
      day
      periods
      periodDuration
      breakDurations
      startTime
      endTime
      teacherprofileID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const onDeleteTeacherSchedule = /* GraphQL */ `
  subscription OnDeleteTeacherSchedule(
    $filter: ModelSubscriptionTeacherScheduleFilterInput
    $owner: String
  ) {
    onDeleteTeacherSchedule(filter: $filter, owner: $owner) {
      id
      day
      periods
      periodDuration
      breakDurations
      startTime
      endTime
      teacherprofileID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const onCreateReportingTeacher = /* GraphQL */ `
  subscription OnCreateReportingTeacher(
    $filter: ModelSubscriptionReportingTeacherFilterInput
  ) {
    onCreateReportingTeacher(filter: $filter) {
      id
      title
      name
      surname
      language
      province
      email
      phone
      registrationDate
      tags
      roles
      productCount
      teacherprofileID
      teacherProfileSchoolId
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateReportingTeacher = /* GraphQL */ `
  subscription OnUpdateReportingTeacher(
    $filter: ModelSubscriptionReportingTeacherFilterInput
  ) {
    onUpdateReportingTeacher(filter: $filter) {
      id
      title
      name
      surname
      language
      province
      email
      phone
      registrationDate
      tags
      roles
      productCount
      teacherprofileID
      teacherProfileSchoolId
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteReportingTeacher = /* GraphQL */ `
  subscription OnDeleteReportingTeacher(
    $filter: ModelSubscriptionReportingTeacherFilterInput
  ) {
    onDeleteReportingTeacher(filter: $filter) {
      id
      title
      name
      surname
      language
      province
      email
      phone
      registrationDate
      tags
      roles
      productCount
      teacherprofileID
      teacherProfileSchoolId
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateTeacherProfile = /* GraphQL */ `
  subscription OnCreateTeacherProfile(
    $filter: ModelSubscriptionTeacherProfileFilterInput
    $owner: String
  ) {
    onCreateTeacherProfile(filter: $filter, owner: $owner) {
      id
      title
      name
      surname
      language
      province
      daysPerWeek
      status
      TeacherSchedules {
        nextToken
        startedAt
        __typename
      }
      TeacherClassSubjects {
        nextToken
        startedAt
        __typename
      }
      TeacherActivities {
        nextToken
        startedAt
        __typename
      }
      TeacherProductsOrders {
        nextToken
        startedAt
        __typename
      }
      School {
        id
        name
        provinces
        isGeneric
        schoolImgKey
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      payfastSubscriptionToken
      sessionToken
      productsOrderShippingDetails
      products
      payfastSubscriptionResponse
      productSubscriptions
      communicationTopics
      payfastSubscriptionPackage
      translateI18n
      smartProductSort
      type
      createdAt
      updatedAt
      owner
      _version
      _deleted
      _lastChangedAt
      teacherProfileSchoolId
      __typename
    }
  }
`;
export const onUpdateTeacherProfile = /* GraphQL */ `
  subscription OnUpdateTeacherProfile(
    $filter: ModelSubscriptionTeacherProfileFilterInput
    $owner: String
  ) {
    onUpdateTeacherProfile(filter: $filter, owner: $owner) {
      id
      title
      name
      surname
      language
      province
      daysPerWeek
      status
      TeacherSchedules {
        nextToken
        startedAt
        __typename
      }
      TeacherClassSubjects {
        nextToken
        startedAt
        __typename
      }
      TeacherActivities {
        nextToken
        startedAt
        __typename
      }
      TeacherProductsOrders {
        nextToken
        startedAt
        __typename
      }
      School {
        id
        name
        provinces
        isGeneric
        schoolImgKey
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      payfastSubscriptionToken
      sessionToken
      productsOrderShippingDetails
      products
      payfastSubscriptionResponse
      productSubscriptions
      communicationTopics
      payfastSubscriptionPackage
      translateI18n
      smartProductSort
      type
      createdAt
      updatedAt
      owner
      _version
      _deleted
      _lastChangedAt
      teacherProfileSchoolId
      __typename
    }
  }
`;
export const onDeleteTeacherProfile = /* GraphQL */ `
  subscription OnDeleteTeacherProfile(
    $filter: ModelSubscriptionTeacherProfileFilterInput
    $owner: String
  ) {
    onDeleteTeacherProfile(filter: $filter, owner: $owner) {
      id
      title
      name
      surname
      language
      province
      daysPerWeek
      status
      TeacherSchedules {
        nextToken
        startedAt
        __typename
      }
      TeacherClassSubjects {
        nextToken
        startedAt
        __typename
      }
      TeacherActivities {
        nextToken
        startedAt
        __typename
      }
      TeacherProductsOrders {
        nextToken
        startedAt
        __typename
      }
      School {
        id
        name
        provinces
        isGeneric
        schoolImgKey
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      payfastSubscriptionToken
      sessionToken
      productsOrderShippingDetails
      products
      payfastSubscriptionResponse
      productSubscriptions
      communicationTopics
      payfastSubscriptionPackage
      translateI18n
      smartProductSort
      type
      createdAt
      updatedAt
      owner
      _version
      _deleted
      _lastChangedAt
      teacherProfileSchoolId
      __typename
    }
  }
`;
